import { AnimationTriggerMetadata, trigger, state, style, transition, animate, keyframes, stagger, query, animateChild } from '@angular/animations';

export const routeFade: AnimationTriggerMetadata =
  trigger('routeAnimation', [
    transition('* <=> *', [
      style({ opacity: 0 }),
      animate('900ms ease', style({ opacity: 1 }))
    ])
  ]);

export const basicFade: AnimationTriggerMetadata =
  trigger('basicFade', [
    transition('void => *', [
      style({ opacity: 0 }),
      animate('150ms linear', style({ opacity: 1 }))
    ]),
    transition('* => void', [
      style({ opacity: 1 }),
      animate('100ms linear', style({opacity: 0}))
    ])
  ]);

export const galleryAnimationFade: AnimationTriggerMetadata =
    trigger('thumbnailFade', [
      state('in', style({ opacity: 1, transform: 'translate(0, 0)' })),
      state('out', style({ opacity: 0 })),
      transition('* => in', [
          style({ opacity: 0, transform: 'translate(-5%, -10%)' }),
          animate('175ms ease', style({ opacity: 1, transform: 'translate(0, 0)' }))
      ]),
      transition('in => out', [
        style({ opacity: 1 }),
        animate('175ms linear', style({opacity: 0}))
      ])
    ]);
export const galleryAnimationStagger: AnimationTriggerMetadata =
    trigger('thumbnailStagger', [
      state('in', style({ opacity: 1, transform: 'translate(0, 0)' })),
      state('out', style({opacity: 0})),
      transition('* => in', [
          query('.staggerTarget', stagger('22ms', [animateChild()]), {optional: true})
      ]),
      transition('in => out', [
          query('.staggerTarget', stagger('22ms', [animateChild()]), {optional: true})
        ])
    ]);
export const filterWindowSlideIn: AnimationTriggerMetadata =
  trigger('filterSlideIn', [
    state('in', style({ transform: 'translate(229px, -55px)' })),
    state('out', style({ transform: 'translate(-100%, -55px)'})),
    transition('* => in', [
      style({ transform: 'translate(-100%, -55px)' }),
      animate('275ms ease-out', style({ transform: 'translate(229px, -55px)' }))
    ]),
    transition('in => out', [
      style({ transform: 'translate(229px, -55px)' }),
      animate('275ms ease-in', style({ transform: 'translate(-100%, -55px)' }))
    ])
  ]);
